import { useSearchParams } from "react-router-dom";

export default function usePaginationParams(defaultSize = 10) {
  const [searchParams, setSearchParams] = useSearchParams();

  // Current values from URL
  const currentPage = Number(searchParams.get("page")) || 1;
  const pageSize = Number(searchParams.get("size")) || defaultSize;

  // Update page and size without removing other query params
  const updateParams = (page = currentPage, size = pageSize) => {
    const params = new URLSearchParams(searchParams); // copy existing params
    params.set("page", String(page));
    params.set("size", String(size));
    setSearchParams(params);
  };

  // Go to specific page
  const setPage = (page) => {
    updateParams(page, pageSize);
  };

  // Change page size (reset page to 1)
  const setSize = (size) => {
    updateParams(1, size);
  };

  // Next / previous helpers
  const nextPage = () => updateParams(currentPage + 1, pageSize);
  const prevPage = () => updateParams(currentPage - 1, pageSize);

  return {
    currentPage,
    pageSize,
    setPage,
    setSize,
    nextPage,
    prevPage,
    setSearchParams,
  };
}
